import { Navigate, Route, Routes } from 'react-router-dom';
import AllergensPage from '../pages/allergens-page';

export const AllergensRoutes = () => {
  return (
    <Routes>
      <Route index element={<AllergensPage />} />
      <Route path=":id" element={<Navigate to="." replace />} />
    </Routes>
  );
};
export default AllergensRoutes;
